import { all, call, fork, put, select, take, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import I from 'immutable'
import { pageIsLoading } from 'domain/loading'
import { jobSelector } from 'domain/manager/selectors'
import { jobStatusSelector } from 'domain/constants'
import * as L from 'domain/locations'
import * as R from 'domain/manager/recruiters'
import * as C from 'domain/manager/clients'
import * as J from 'domain/manager/jobs'
import * as JD from 'domain/manager/jobDrafts'
import * as Jobs from 'domain/jobs'
import * as Router from 'domain/router'

export function* jobsEdit() {
  yield all([
    fork(getRecruiters),
    fork(getRecruitersWithOthers),
    fork(postJobs),
    fork(getJob),
    fork(putJob),
    fork(deleteJob),
    fork(getClientsForFob),
    fork(initialLoad),
    fork(extractSkills),
    fork(updateRecruiters),
    fork(improveJobDescription)
  ])
}

export function* jobsClone() {
  yield all([
    fork(getRecruiters),
    fork(postJobs),
    fork(getJobForClone),
    fork(getClientsForFob),
    fork(initialLoad),
    fork(updateRecruiters),
    fork(improveJobDescription)
  ])
}

function* updateRecruiters() {
  yield takeLatest(Jobs.updateJobRecruiters.type, Jobs.ensureUpdateJobRecruiters)
  yield take(Jobs.updateJobRecruiters.success)
  yield put(push('/jobs?ownership=all&page=1'))
}

function* getRecruiters() {
  yield takeLatest(R.recruitersList.type, R.ensureRecruitersList)
  yield take(R.recruitersList.success)
}

function* extractSkills() {
  yield takeLatest(Jobs.extractSkills.type, Jobs.ensureExtractSkills)
  yield take(Jobs.extractSkills.success)
}

function* getRecruitersWithOthers() {
  yield takeLatest(R.recruitersListWithOthers.type, R.ensureRecruitersList)
  yield take(R.recruitersList.success)
}

function* postJobs() {
  yield takeLatest(J.postJob.TRIGGER, J.ensurePostJob)
  const action = yield take(J.postJob.SUCCESS)
  const query = yield select(Router.query)
  const draftId = query && query.draftId
  const jobId = action && action.payload && action.payload.get && action.payload.get('id')
  if (draftId && jobId) {
    yield call(JD.ensureMarkManagerJobDraftConverted, {
      type: JD.markManagerJobDraftConverted.request,
      payload: { id: Number(draftId), jobId: Number(jobId) }
    })
  }
  yield put(push('/jobs'))
}

function* getJob() {
  yield takeLatest(J.jobData.type, J.ensureGetJob)
  yield take(J.jobData.success)
  const {
    params: { id }
  } = yield select(Router.matchRoutes)
  const job = yield select(jobSelector)
  const jobStatus = yield select(jobStatusSelector)
  if (job && !job.isEmpty() && job.get('status') === jobStatus.get('closed')) {
    yield put(push(`/jobs/view/${id}`))
  }
}
function* getJobForClone() {
  yield takeLatest(J.jobData.type, J.ensureGetJob)
  yield take(J.jobData.success)
}

function* putJob() {
  yield takeLatest(J.putJob.TRIGGER, J.ensurePutJob)
  yield take(J.putJob.SUCCESS)
  yield put(push('/jobs'))
}

function* deleteJob() {
  yield takeLatest(J.deleteJob.TRIGGER, J.ensureDeleteJob)
  yield take(J.deleteJob.SUCCESS)
  yield put(push('/jobs'))
}

function* getClientsForFob() {
  yield takeLatest(C.clientsListForJob.type, C.ensureGetClients)
}

function* improveJobDescription() {
  yield takeLatest(J.improveJobDescription.TRIGGER, J.ensureImproveJobDescription)
  yield take(J.improveJobDescription.SUCCESS)
}

function* initialLoad() {
  yield put({ type: pageIsLoading, payload: true })
  yield put({ type: Jobs.extractSkills.success, payload: [] })
  const query = yield select(Router.query)
  const draftId = query && query.draftId
  if (!draftId) {
    yield put({ type: JD.managerJobDraftData.success, payload: I.fromJS({}) })
  }
  try {
    const effects = [
      call(L.ensureGetCounties),
      call(R.ensureRecruitersList),
      call(J.ensureGetJob),
      call(C.ensureGetClients)
    ]
    if (draftId) {
      effects.push(
        call(JD.ensureGetManagerJobDraft, {
          type: JD.managerJobDraftData.request,
          payload: { id: Number(draftId) }
        })
      )
    }
    yield all(effects)
    yield put({ type: 'profile/CLEAR_CITIES' })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}
